export default __webpack_public_path__ + "static/media/elect.3d4a5c0c.png";